import { render, staticRenderFns } from "./ls-manage.vue?vue&type=template&id=c56695e0&scoped=true"
import script from "./ls-manage.vue?vue&type=script&lang=js"
export * from "./ls-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56695e0",
  null
  
)

export default component.exports